export default __webpack_public_path__ + "static/media/landing_page_desktop.20ae51e2.jpg";